import React, { Component } from 'react';
import { Card, CardMedia, CardTitle } from 'material-ui/Card';
import { Link } from 'react-router';
import TextField from 'material-ui/TextField';
import { deepOrange500 } from 'material-ui/styles/colors';
import RaisedButton from 'material-ui/RaisedButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppStore from '../../stores/app-store.js'
import { statusCartas } from '../../actions/app-actions.js'
import { historiaActions } from '../../actions/app-actions.js'
import './CartaX.css';
import './CartaX.css';

const muiTheme = getMuiTheme({
    palette: {
        accent1Color: deepOrange500,
    },
});

const style = {
    margin: 12,
    float: 'right',
};

class CartaX extends Component {
    constructor() {
        super();
        this.state = {
            estadocartas: AppStore.getCartas(),
            jogadorAtual: AppStore.getJogadorAtual(),
            nomeJogador: AppStore.getNomeJogador(),
            cartaX: {
                idoriginal: 0,
                key: 0,
                imgfrente: './imagens/cartas/acoes/Ajudar.png',
                titulofrente: 'Ajudar',
                imgverso: './imagens/cartas/fundos/Acoes.png',
                tituloverso: 'Ações',
                jogador: 0,
                jaescolhida: false,
                frente: true,
                selecionada: false,
            },
            historiacarta: {
                idoriginal: 0,
                sequencia: 0,
                historia: '',
            },
            legendas: AppStore.legendas,
        };
        this.onChangeLingua = this.onChangeLingua.bind(this);
    }

    componentWillMount() {
        this.setState({
            estadocartas: AppStore.getCartas(),
            nomeJogador: AppStore.getNomeJogador(),
            cartaX: AppStore.getCartaX(),
        });
        AppStore.addChangeCartaXListener(this.onChange);
        AppStore.addChangeLinguaListener(this.onChangeLingua);
    }

    componentWillUnmount() {
        let copia = this.state.estadocartas.slice(0);
        for (let i = 0; i < copia.length; i++) {
            if (copia[i].selecionada === true) {
                copia[i].selecionada = false;
                copia[i].jaescolhida = true;
            }
        }
        AppStore.removeChangeCartaXListener(this.onChange)
        AppStore.removeChangeLinguaListener(this.onChangeLingua);
        statusCartas.atualiza(copia);
        historiaActions.sequenciaCarta(this.state.cartaX.idoriginal);
    }

    onChangeLingua() {
        this.setState({
            legendas: AppStore.legendas,
        })
    }

    onChange() {
        this.embaralhando = false;
        this.setState({
            cartaX: AppStore.getCartaX(),
        })
        historiaActions.sequenciaCarta(this.state.cartaX);
    }

    handleInputChange = (event) => {
        this.setState({
            historiacarta: {
                historia: event.target.value,
            }
        });
        historiaActions.sequenciaHistoria(event.target.value);
    };

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="CartaX">
                    <h1>{this.state.nomeJogador}</h1>
                    <h2>{this.state.legendas.historia}</h2>
                    <div className="ui-g">
                        <div className="ui-g-7">
                            <Card >
                                <CardMedia mediaStyle={{ maxWidth: '350px', maxHeight: '550px' }} overlay={<CardTitle titleStyle={{ fontFamily: 'OpenSans' }} subtitleStyle={{ fontFamily: 'OpenSans' }} title={this.state.legendas.LINGUA === 'POR' ? this.state.cartaX.titulofrente : this.state.cartaX.titulofrenteingles} subtitle={this.state.legendas.LINGUA === 'POR' ? this.state.cartaX.tituloverso : this.state.cartaX.tituloversoingles} />} style={{ backgroundColor: 'coral' }}>
                                    <img src={this.state.cartaX.imgfrente} alt="imagem" />
                                </CardMedia>
                            </Card>
                        </div>
                        <div className="ui-g-5">
                            <TextField
                                style={{ maxWidth: '90%', fontFamily: 'Arial', color: 'white' }}
                                textareaStyle={{ color: 'white' }}
                                inputStyle={{ color: 'white' }}
                                hintStyle={{ color: 'white' }}
                                hintText={this.state.legendas.sobre}
                                floatingLabelText={this.state.legendas.conte}
                                floatingLabelStyle={{ color: 'white' }}
                                multiLine={true}
                                rows={4}
                                rowsMax={4}
                                value={this.state.historiacarta.historia}
                                onChange={this.handleInputChange}
                            />
                            <RaisedButton containerElement={<Link to="/categoria" />}
                                linkButton={true}
                                label={this.state.legendas.avancar}
                                style={style}
                                primary={true}
                            />
                            <RaisedButton containerElement={<Link to="/mostrahistoria" />}
                                linkButton={true}
                                label={this.state.legendas.terminar}
                                style={style}
                                primary={true}
                            />
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default CartaX;



// WEBPACK FOOTER //
// ./src/componentes/cartax/CartaX.js